/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataStorageUnitKey } from './businessObjectDataStorageUnitKey';


export interface BusinessObjectDataStorageUnitStatusUpdateResponse { 
    businessObjectDataStorageUnitKey: BusinessObjectDataStorageUnitKey;
    /**
     * The status of the Business Object Data Storage Unit
     */
    status: string;
    /**
     * The status of the Business Object Data Storage Unit prior to the update
     */
    previousStatus: string;
}
